import {fromJS} from 'immutable'

/**
 * Actions
 */
const SET_NAV_SEARCH = 'expii/ui/ENABLE_NAV_SEARCH'
const TOGGLE_NAV_DROPDOWN = 'expii/ui/TOGGLE_NAV_DROPDOWN'
const TOGGLE_SEARCH_IS_FOCUSED = 'expii/ui/TOGGLE_SEARCH_IS_FOCUSED'

/**
 * Action Creators
 */
export function setNavSearch(isOn) {
  return { type: SET_NAV_SEARCH, isOn }
}
export function toggleNavDropdown(isOn) {
  return { type: TOGGLE_NAV_DROPDOWN, isOn }
}
export function toggleSearchIsFocused(isFocused) {
  return { type: TOGGLE_SEARCH_IS_FOCUSED, isFocused }
}

// export type Actions = ExtractReturn<typeof attemptAPI> |
//                       ExtractReturn<typeof processLogin>;

/**
 * Reducer
 */
const defaultUiState = fromJS({
  navSearchEnabled: false,
  dropdownIsToggled: false,
  searchIsFocused: false,
})

export default function reducer(state = defaultUiState, action) {
  switch (action.type) {
  case SET_NAV_SEARCH:
    return state.set('navSearchEnabled', action.isOn)
  case TOGGLE_NAV_DROPDOWN:
    return state.set('dropdownIsToggled', action.isOn)
  case TOGGLE_SEARCH_IS_FOCUSED:
    return state.set('searchIsFocused', action.isFocused)
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/ui.js